module.exports = __webpack_public_path__ + "static/media/27.34de5983.png";